import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth')({
  component: AuthLayout,
})

function AuthLayout() {
  return (
    <div className="flex pt-4 md:pt-32 items-center justify-center">
      <div className="w-full max-w-md rounded-lg bg-background p-8 shadow-md border border-border">
        <Outlet />
      </div>
    </div>
  )
}
